import { render, staticRenderFns } from "./ArticleVideo.vue?vue&type=template&id=4349f209&scoped=true"
import script from "./ArticleVideo.vue?vue&type=script&lang=js"
export * from "./ArticleVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4349f209",
  null
  
)

export default component.exports